<template>
    <li><span class="pagination-ellipsis">&hellip;</span></li>
</template>
